import React from 'react';
import { Row, Grid } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';
import { map } from 'lodash';
import Icon from 'components/Icon/Icon';
import { productNominalDetailsShape } from 'propTypesObjects';
import { PipeFactsStatus, Stages } from './PipeFactsInspectionTracker.styles';

const {
  custom_blue: customBlue,
  color_white: colorWhite,
  color_grey_500: colorGrey500,
  color_blue_700: colorBlue700,
  custom_green: customGreen,
} = variables;

function PipeFactsInspectionTracker({ productDetails }) {
  const inspectionStage = productDetails?.inspection_status;

  const inspectionLevels = [
    {
      stage: 'Field Inspection',
      complete: inspectionStage >= 1,
      pending: inspectionStage === 0,
      icon: '/images/fieldInspectionList.svg',
      iconSize: '60% 60%',
    },
    {
      stage: 'Receiving Inspection',
      complete: inspectionStage >= 2,
      pending: inspectionStage === 1,
      icon: '/images/receivingTruck.svg',
      iconSize: '65% 65%',
    },
    {
      stage: 'Final Inspection',
      complete: inspectionStage >= 3,
      pending: inspectionStage === 2,
      icon: '/images/finalInspectionCheck.svg',
      iconSize: '70% 70%',
    },
    {
      stage: 'Certified Report',
      complete: inspectionStage >= 3,
      pending: inspectionStage === 2,
      icon: '/images/certifiedReportHandShake.svg',
      iconSize: '70% 70%',
    },
  ];

  return (
    <PipeFactsStatus>
      <Grid>
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ padding: '3% 3%' }}>
            <img
              alt="Pipefacts Logo"
              style={{
                maxWidth: '90%',
              }}
              src="/images/pipeFactsV2.svg"
            />
          </div>
        </Row>
        <Stages>
          <ul className="stage_list">
            {map(inspectionLevels, (level) => (
              <li className="stage" key={level.stage}>
                <div
                  className="stage_icon"
                  style={{
                    backgroundImage: `url(${level.icon})`,
                    backgroundSize: level.iconSize,
                    backgroundColor: level.complete ? colorBlue700 : colorWhite,
                    marginTop: '8px',
                  }}
                />
                <div className={`stage_title ${level.stage}`}>
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <span
                      className="stageText"
                      style={{
                        color: level.complete ? customBlue : colorGrey500,
                        fontWeight: level.complete ? 700 : 400,
                      }}
                    >
                      {level.stage}
                    </span>
                    <span
                      className="stage_status"
                      style={{
                        color:
                          level.complete || level.pending
                            ? colorBlue700
                            : colorGrey500,
                      }}
                    >
                      {level.complete && 'Complete!'}
                      {level.pending && 'Pending...'}
                      {level.complete && (
                        <Icon
                          style={{ paddingLeft: '10%' }}
                          fontAwesome
                          color={customGreen}
                          icon="check-circle"
                          fontSize="15px !important"
                        />
                      )}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Stages>
      </Grid>
    </PipeFactsStatus>
  );
}

PipeFactsInspectionTracker.propTypes = {
  productDetails: productNominalDetailsShape,
};

export default PipeFactsInspectionTracker;
